import React from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import PostListContainer from '../../../features/page/post/post/PostListContainer'

interface IProps {
    className?: string
}

const PostListPage: React.FC<IProps> = ({className}) => {
    return (
        <PageLayout title={'Post'} className={className}>
            <PostListContainer />
        </PageLayout>
    )
}

export default PostListPage
